import * as partials from "../partials/types";

export const PROFILE = partials.createRequestTypes("PROFILE");
export const LOAD_PROFILE_PAGE = "LOAD_PROFILE_PAGE";

export * from "../partials/types";
